import Vue from 'vue'
import Router from 'vue-router'
import {projectTitle} from '@/config'

// 统一错误页面
/* const Error = () => import('pages/error/Error') */
const NotFound = () => import('pages/error/404')
// 首页
const Home = () => import('pages/home/home')
const laws = () => import('pages/home/laws')
const lawDetail = () => import('pages/home/lawDetail')
const caseNotice = () => import('pages/home/caseNotice')


// 自组立案
const Webview = () => import('pages/webview/webview')
//文书
const documentList = () => import('pages/documentService/documentList')
const templatePage = () => import('pages/documentService/templatePage')  //文书模版
// 我的案件
const myCaseFile = () => import('pages/myCaseFile/myCaseFile')
const caseList = () => import('pages/myCaseFile/caseList')
const caseDetail = () => import('pages/myCaseFile/caseDetail')
const myCase = () => import('pages/myCaseFile/myCase')
const correctFile = () => import('pages/myCaseFile/correctFile')
const caseInfo = () => import('pages/myCaseFile/caseInfo')
// 全部功能
const allViews = () => import('pages/home/allViews')
//计算器
const calculator = () => import('pages/calculator/calculator')
const calculatoDetail = () => import('pages/calculator/detail')

//我要登记
const setUpCase = () => import('pages/case/index')

// 仲裁请求
const arbitrationClaims = () => import('pages/case/arbitrationClaims')


Vue.use(Router)

// 配置路由
const router = new Router({
  mode: 'history',
  routes: [
    {
      path: '/',
      name: 'home',
      component: Home,
      meta: {
        title: '微法亭一体机',
        isKeepAlive: true
      }
    },
    {
      path: '/laws',
      name: 'laws',
      component: laws,
      meta: {
        title: '法律法规',
        NoHeader:true
      }
    },
    // 我的案件
    {
      path: '/myCaseFile',
      name: 'myCaseFile',
      component: myCaseFile,
      meta: {
        title: '我的案件',
      }
    },
    {
      path: '/caseList',
      name: 'caseList',
      component: caseList,
      meta: {
        title: '我的案件',
        // isKeepAlive: true
      }
    },
    {
      path: '/caseDetail',
      name: 'caseDetail',
      component: caseDetail,
      meta: {
        title: '我的案件',
      }
    },
    {
      path: '/correctFile',
      name: 'correctFile',
      component: correctFile,
      meta: {
        title: '补正材料',
      }
    },
    {
      path: '/myCase',
      name: 'myCase',
      component: myCase,
      meta: {
        title: '我的案件',
      }
    },
    {
      path: '/caseInfo',
      component: caseInfo,
      meta: {
        title: '案件信息',
      }
    },
    // 全部功能
    {
      path: '/allViews',
      name: 'allViews',
      component: allViews,
      meta: {
        title: '全部功能',
      }
    },
    {
      path: '/webview',
      name: 'webview',
      component: Webview,
      meta: {
        title: 'web',
        NoHeader: true,
      }
    },
    {
      path: '*',
      name: 'notFound',
      component: NotFound,
      meta: {
        title: '404',
      }
    },
    {
      path: '/calculator',
      name: 'calculator',
      component: calculator,
      meta: {
        title: '计算器',
      }
    },
    {
      path: '/calculator/detail',
      name: 'calculatoDetail',
      component: calculatoDetail,
      meta: {
        title: '计算器',
      }
    },
    {
      path: '/documentService/documentList',
      name: 'documentList',
      component: documentList,
      meta: {
        title: '文书',
      }
    }, {
      path: '/templatePage',
      name: 'templatePage',
      component: templatePage,
      meta: {
        title: '文书模版',
      }
    }, {
      path: '/home/caseNotice',
      name: 'caseNotice',
      component: caseNotice,
      meta: {
        title: '仲裁服务指南',
      }
    }, {
      path: '/home/lawDetail',
      name: 'lawDetail',
      component: lawDetail,
      meta: {
        title: '法律法规详情',
      }
    }, {
      path: '/setupcase',
      name: 'setupcase',
      component: setUpCase,
      meta: {
        title: '我要登记',
      }
    }, {
      path: '/case/arbitrationClaims',
      name: 'arbitrationClaims',
      component: arbitrationClaims,
      meta: {
        title: '仲裁请求',
      }
    }
  ]
})

// 进入路由后设置文档标题
router.afterEach((to, from) => {
  document.title = to.matched.reduce((acc, cur) => {
    return cur.meta.title || acc
  }, projectTitle)
  window.scrollTo(0, 0)
})

export default router



// WEBPACK FOOTER //
// ./src/router/index.js